<template>
  <f7-page id="reg-personalise-account" name="reg-personalise-account" @page:afterin="afterin">
      <f7-navbar class="view-mobile no-border">
          <f7-nav-left class="back-button">
              <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
      </f7-navbar>

      <div class="block">

        <div class="fs-24 fw-bold" v-html="title"></div>
        <div class="fs-14 fw-medium text-color-gray mt-md text-align-center d-none">{{$t('regis-personalise-account-desc')}}</div>

        <div class="mt-20">
          <transition name="fade">
            <f7-card
                class   ="alert alert-danger mb-md"
                v-show  ="alertCard.show"
            >
                <div v-html="alertCard.title" slot="header"></div>
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i> 
            </f7-card>
          </transition>

          <f7-list class="form-group no-margin">
            <f7-list-input
              id            ="reg-customer-alias"
              input-id      ="customerAlias"
              name          ="customerAlias"
              type          ="text"
              :label        ="$t('regis-personalise-account-title')"
              placeholder   =""
              @change       ="customerAliasTemp = $event.target.value; setCustomerAlias($event.target.value); validateInput($event.target);"
              :value        ="customerAlias"
              autocomplete  ="off"
              outline
              floating-label
              clear-button
            >
            </f7-list-input>
          </f7-list>
        </div>

        <f7-button round large fill @click="goToNextPage('continue')" class="mt-5 view-desktop" :disabled="!isNextButtonValid">{{$t('general-text-continue')}}</f7-button>

        <f7-button round large fill @click="goToNextPage('skip')" class="mt-md view-desktop color-gray3 text-color-green" :disabled="!isNextButtonValid">{{$t('general-text-skip')}}</f7-button>
      </div>

      <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button  view-mobile">        
        <f7-button large fill @click="goToNextPage('continue')" :disabled="false">
            {{$t('general-text-continue')}}
        </f7-button>
        <f7-button class="color-gray3 text-color-green" large fill @click="goToNextPage('skip')" :disabled="false">
          {{$t('general-text-skip')}}
        </f7-button>
      </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    mounted (){
      const imgURL = this.getImg('logo-wandr_e-compact.svg')
      this.title = this.$t('regis-personalise-account-title-2', [imgURL])
      console.log("Register personalise account name isAxsr : "+this.isAxsr);
    },
    data() {
      return {
        customerAliasTemp     : "",
        isNextButtonValid     : true,
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        title                 : "",
      };
    },
    methods: {
      ...mapActions('customer', ['setCustomerAlias','validateInput']),
      ...mapActions('registration', ['setIsSkipAlias']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      goToNextPage(choice){
        this.showPreloader();
        if(choice == "continue"){
          this.setIsSkipAlias(false)
          //this.setCustomerAlias(this.customerAliasTemp)
          this.validateInput({id: "customerAlias", value: this.customerAlias});
          if(this.isValidAlias === true){ // ALIAS VALID
            if(this.singpassUrl != ""){
              if(this.isAxsr){
                this.$f7router.navigate("/register-mobile-no");
              }else{
                this.$f7router.navigate("/register-email-password");
              }
            }else{
              this.$f7router.navigate("/register-mobile-no");
            }            
          }          
          this.hidePreloader();
        }else if(choice == "skip"){
          this.setIsSkipAlias(true)
          if(this.singpassUrl != ""){
            if(this.isAxsr){
              this.$f7router.navigate("/register-mobile-no");
            }else{
              this.$f7router.navigate("/register-email-password");
            }
          }else{
            this.$f7router.navigate("/register-mobile-no");
          }          
          this.hidePreloader();
        }        
      },

      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },

      backButton() {
          switch(this.routerTo) {
              default          : this.$f7router.navigate("/register-tnc"); break;
          }
      },
     
    },
    components: {

    },
    computed: {
      ...mapGetters('customer', [
        'customerAlias',
        'isValidAlias',
      ]),
      ...mapGetters('registration', [
        'singpassUrl',
        'isAxsr',
      ])
    },
  }
</script>